import { ChangeDetectorRef, Inject, Injectable } from '@angular/core';
import { inject } from '@angular/core/testing';
import { EventEmitter } from 'protractor';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorModalService {
  public onModalChnage = new BehaviorSubject<boolean>(false);
  public isVisible = false;
  public isCloseBtn = false;
  public title = '';
  public detail = '';
  constructor() {
    this.onModalChnage.subscribe((val) => {
      this.isVisible = val;
    });
  }

  showModal(data) {
    this.title = data?.title;
    this.detail = data?.detail;
    this.isCloseBtn = false;
    this.onModalChnage.next(true);
  }

  httpError(type = 'custom', message = '') {
    this.isVisible = true;
    this.title = 'Something went wrong';
    this.isCloseBtn = true;
    this.detail = message;
    if (type === 'connection' && !message) {
      this.detail = 'Cannot connect to the server';
    } else if (type === 'response' && !message) {
      this.detail = 'Server response not correct';
    }
    this.onModalChnage.next(true);
  }

  hideModal() {
    this.onModalChnage.next(false);
  }
}
